const TEST_GCLID_PATTERNS = [
  /^TEST_/i,
  /^PLAYWRIGHT_/i,
  /^FAKE_/i,
  /OPERATOR_CHECK/i,
  /DEBUG/i,
];

const GCLID_ALLOWED_CHARS = /^[A-Za-z0-9_-]+$/;

export function normalizeTrackableGclid(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string') {
    return null;
  }

  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }

  if (!GCLID_ALLOWED_CHARS.test(trimmed)) {
    return null;
  }

  if (TEST_GCLID_PATTERNS.some((pattern) => pattern.test(trimmed))) {
    return null;
  }

  return trimmed;
}

export function isTrackableGclid(raw: string | null | undefined): raw is string {
  return normalizeTrackableGclid(raw) !== null;
}
